module.exports = __webpack_public_path__ + "img/icon-arrow-black.789d23a1.svg";